import { IJsonQuery } from '../json_query';
import { IOffer } from '../offer';
import { IMakeRequest } from '../utils/request';
import { mergeBaseUri, mergePaths } from '@cian/http-api/shared';

export interface IQsToUris {
  [key: string]: string;
}

interface IGetOffersResponse {
  offersSerialized: IOffer[];
  qsToUris: IQsToUris;
}

export interface IGetSuggestionIds {
  jsonQuery: IJsonQuery;
  offerIds: number[];
  pageNumber: number;
  queryString: string;
}

export interface IInfiniteSearchResult {
  itemId: number;
  modelVersion: number;
  score: number;
}

export interface IGetSuggestionIdsResponse {
  infiniteSearchResult: IInfiniteSearchResult[];
}

export interface IOffersMLResponse {
  offersSerialized: IOffer[];
  qsToUris: IQsToUris;
}

export const getOffers = (
  makeRequest: IMakeRequest,
  searchOffersApiBaseUrl: string,
  cianOfferIds: number[],
  jsonQuery: IJsonQuery,
): Promise<IOffersMLResponse> => {
  const uri = mergeBaseUri(searchOffersApiBaseUrl, {
    path: path => mergePaths(path, '/v1/get-offers-by-ids-desktop/'),
  });

  return makeRequest({
    uri,
    body: JSON.stringify({
      cianOfferIds,
      jsonQuery,
    }),
    method: 'POST',
  }).then((response: IGetOffersResponse) => {
    const { offersSerialized, qsToUris } = response;

    return {
      offersSerialized,
      qsToUris,
    };
  });
};

export const getSuggestionIds = (
  makeRequest: IMakeRequest,
  searchOffersApiBaseUrl: string,
  params: IGetSuggestionIds,
): Promise<IInfiniteSearchResult[]> => {
  const uri = mergeBaseUri(searchOffersApiBaseUrl, {
    path: path => mergePaths(path, '/v1/get-infinite-search-result-desktop/'),
  });

  return makeRequest({
    uri,
    body: JSON.stringify(params),
    method: 'POST',
  }).then((response: IGetSuggestionIdsResponse) => {
    return response.infiniteSearchResult;
  });
};
